import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, signal } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/shared/pipes/safe-html.pipe';
import { TextTruncationService } from '../../../core/services/text-truncation/text-truncation.service';

export const MAX_CHARACTERS_TO_SHOW = 200;

@Component({
  standalone: true,
  selector: 'base-short-description',
  templateUrl: './short-description.component.html',
  styleUrls: ['./short-description.component.scss'],
  imports: [CommonModule, SafeHtmlPipe]
})
export class ShortDescriptionComponent {
  private textTruncationService = inject(TextTruncationService);

  MAX_CHARACTERS_TO_SHOW = MAX_CHARACTERS_TO_SHOW;

  readonly description = input<string>('');
  private _isExpanded = signal(false);

  readonly truncatedResult = computed(() => {
    return this.textTruncationService.truncateText(
      this.description(),
      MAX_CHARACTERS_TO_SHOW,
      this._isExpanded()
    );
  });

  toggleViewMoreComments() {
    this._isExpanded.set(!this._isExpanded());
  }

  get isExpanded() {
    return this._isExpanded();
  }
}

